import { render, staticRenderFns } from "./HazardTableSettings.vue?vue&type=template&id=48c6fa54&scoped=true"
import script from "./HazardTableSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./HazardTableSettings.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HazardTableSettings.vue?vue&type=style&index=0&id=48c6fa54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c6fa54",
  null
  
)

export default component.exports